import React from 'react';

export default function WiltFirstRunModal({ isOpen, onAcknowledge, strictMode = false }) {
  if (!isOpen) return null;

  const graceSeconds = strictMode ? 15 : 30;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="wilt-first-run-title"
      className="fixed inset-0 z-[1000] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      onClick={onAcknowledge}
    >
      <div
        className="w-full max-w-md glass-card p-6 space-y-5 max-h-[calc(100vh-2rem)] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex flex-col items-center gap-3 text-center">
          <svg viewBox="0 0 100 100" width="72" height="72" aria-hidden="true">
            <ellipse cx="50" cy="90" rx="22" ry="4" fill="#3d2010" opacity="0.3" />
            <line x1="50" y1="88" x2="50" y2="38" stroke="#2d5016" strokeWidth="4" strokeLinecap="round" transform="rotate(8 50 60)" />
            <ellipse cx="38" cy="50" rx="9" ry="4" fill="#86efac" transform="rotate(-25 38 50)" opacity="0.7" />
            <ellipse cx="62" cy="55" rx="9" ry="4" fill="#86efac" transform="rotate(35 62 55)" opacity="0.6" />
            <circle cx="48" cy="42" r="6" fill="#f87171" opacity="0.8" />
          </svg>
          <h3 id="wilt-first-run-title" className="text-xl font-semibold text-[color:var(--color-text-primary)]">
            Keep your plant alive
          </h3>
        </div>

        <div className="space-y-3 text-sm text-[color:var(--color-text-secondary)] leading-relaxed">
          <p>
            While a session is running, Pomogrow watches whether the app stays in the foreground.
          </p>
          <p>
            If you <strong className="text-[color:var(--color-text-primary)]">switch to another app or lock your phone</strong>, your plant starts wilting immediately.
          </p>
          <p>
            Return within{' '}
            <strong className="text-[color:var(--color-text-primary)]">{graceSeconds} seconds</strong>{' '}
            to save it. Stay away longer and the session is lost — no XP, no streak credit, no plant in the garden.
          </p>
        </div>

        <button
          type="button"
          onClick={onAcknowledge}
          className="w-full px-4 py-3 rounded-xl bg-gradient-to-br from-tomato-700 via-tomato-500 to-tomato-500 text-white font-semibold shadow-glow-sm hover:-translate-y-0.5 transition-transform"
        >
          Got it — let's grow
        </button>
      </div>
    </div>
  );
}
